/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('DetailsTicketCtrl', function($scope, $filter, identity, ticket, Ticket, ErrorThrower, marked) {
    $scope.ticket = ticket;
    $scope.me     = identity;
    const errorManager  = new ErrorThrower({
        "Échec de l'envoi du message"         : `Une erreur est survenue lors de \
l'envoi du message, veuillez réessayer ultérieurement.`,
        'Échec lors de la fermeture du ticket': `Une erreur est survenue lors de \
la fermeture du ticket, veuillez réessayer ultérieurement.`
    });

    $scope.sendMessage = function() {
        $scope.error   = undefined;
        ticket         = new Ticket({ id: $scope.ticket.id });
        ticket.message = $scope.message;
        return ticket
        .$update()
        .then(function(updated_ticket) {
            $scope.message = undefined;
            $scope.error   = undefined;
            return $scope.ticket  = updated_ticket.data;}).catch(function(api_error) {
            $scope.error = "Échec de l'envoi du message";
            return errorManager.minor($scope.error);
        });
    };

    return $scope.close = function() {
        $scope.error = undefined;
        ticket       = new Ticket({ id: $scope.ticket.id });
        return ticket
        .$close()
        .then(function(closed_ticket) {
            $scope.message = undefined;
            $scope.error   = undefined;
            return $scope.ticket  = closed_ticket.data;}).catch(function(api_error) {
            $scope.error = 'Échec lors de la fermeture du ticket';
            return errorManager.minor($scope.error);
        });
    };
});
